<template>
  <div class="p-t-40">
    <div class="full-page-width relative locations p-b-40">
      <ConfirmationBar
        :showSavebar="showSavebar"
        @confirm="saveItemData"
        @cancel="cancel"
      />
      <div class="flex-center m-b-40 h-40">
        <div class="flex-center">
          <Btn
            @click.native="routeIt"
            class="light bordered empty d-inline-block m-r-15 fix-40"
            :icon="{
              name: 'arrowLeftBig',
              size: '20',
            }"/>
          <p class="user-name">{{ form.name }}</p>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-xs-8">
            <div class="card">
              <InputSelect
                v-if="get_user.is_admin"
                class="m-b-25"
                :multiSelect=true
                :preselected="form.accessibleForSubaccounts"
                :label="$t('accessible_for_accounts')"
                @change="selectAccessibleSubaccount"
                :rules="{required: true}"
                :options="getAllowedSubaccounts"/>
              <InputText
                class="m-b-25"
                v-model="form.name"
                :label="$t('name')"
                :rules="{required: true}"/>
              <InputTextArea
                class="m-b-25"
                :label="$t('description')"
                :rules="{required: false}"
                textAreaStyle="min-height: 178px"
                v-model="form.description" />
              <div class="row">
                <div class="col-xs-6">
                  <InputText
                    v-model="form.skuCode"
                    :label="$t('sku_code')"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-6">
                  <InputText
                    v-model="form.eanNumber"
                    :label="$t('ean_number')"
                    :rules="{required: false}"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="card m-b-25">
              <div class="d-inline-block">
                <Toggle
                  id="isVisibleToggle"
                  class="m-r-10"
                  v-model="form.isVisible"
                  :label="$t('is_visible')"/>
                {{ $t('is_visible') }}
              </div>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="user-card">
              <div class="card" style="height: 433px">
                <div class="image-holder showIcon" style="height: 300px;width: 250px">
                  <div class="upload-image" @click="uploadImage">
                    <input
                      accept="image/*"
                      @change="imageSelected"
                      type="file"
                      ref="imageUploadInput"
                      style="display:none">
                    <Icon
                      name="camera"
                      :size="34"/>
                  </div>
                  <div style="height: 300px;width: 250px" class="image-placeholder">
                    <img v-if="form.image" :src="form.image" alt="image"/>
                    <div v-else class="upload-image-no-image">
                      <Icon
                        name="camera"
                        :size="34"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 class="m-b-20 m-t-40 section-title">{{ $t('details') }}</h2>
      <div class="card">
        <div class="row">
          <div class="col-xs-2">
            <WeightSelect
              :label="$t('Unit weight')"
              v-model="form.unitWeight"
            />
          </div>
          <CountrySelect
            class="col-xs-3"
            v-model="form.originCountry"
            :label="$t('Origin')"/>
          <div class="col-xs-3">
            <InputText
              v-model="form.hsCode"
              :label="$t('HS code')"
              :rules="{required: false}"/>
          </div>
          <div class="col-xs-2">
            <CurrencySelect
              v-model="form.salesPrice"
              :label="$t('sales_price')"/>
          </div>
          <div class="col-xs-2">
            <CurrencySelect
              v-model="form.purchasePrice"
              :label="$t('purchase_price')"/>
          </div>
        </div>
      </div>
      <div class="m-t-40">
        <h2 class="m-b-20 section-title">{{ $t('additional_information') }}</h2>
        <div class="card">
          <div class="d-inline-block">
            <Toggle
              id="isShowDangerousGoods"
              class="m-r-10"
              v-model="showDangerousGoods"
              :label="$t('dangerous_goods')"/>
            {{ $t('dangerous_goods') }}
          </div>
          <div v-if="showDangerousGoods">
            <div class="separator"></div>
            <!-- LIMITED QUANTITY -->
            <div class="row">
              <div class="col-xs-4">
                <!-- ENV HAZARD -->
                <div class="d-inline-block m-r-40">
                  <Toggle
                    id="isEnvironmentalHazard"
                    class="m-r-10"
                    v-model="isEnvironmentalHazard"
                    :label="$t('is_environmental_hazard')"/>
                  {{ $t('is_environmental_hazard') }}
                </div>
              </div>
              </div>

            <div class="separator"></div>
            <!-- ADR, IATA, IMDG - DANGEROUS GOODS FIELDS -->
              <div class="row m-b-30">
                <div class="col-xs-6">
                  <InputSelect
                    v-model="form.dangerousGoodsJson.dangerousGoodsId"
                    @change="setDangerousGoodsOptions"
                    :options="dangerousGoodsOptions"
                    :label="$t('un_number')"
                    :rules="{required: true}"/>
                </div>
                <div class="col-xs-2">
                  <WeightSelect
                    v-model="form.dangerousGoodsJson.bruttoWeight"
                    :selectionType="'dangerous_goods'"
                    :label="$t('brutto_weight')"
                    :rules="{required: true}"/>
                </div>
                <div class="col-xs-2">
                  <WeightSelect
                    v-model="form.dangerousGoodsJson.netWeight"
                    :selectionType="'dangerous_goods'"
                    :label="$t('net_weight')"
                    :rules="{required: true}"/>
                </div>
                <div class="col-xs-2">
                  <WeightSelect
                    v-model="form.dangerousGoodsJson.nemWeight"
                    :selectionType="'nem_weight'"
                    :label="$t('nem_weight')"
                    :rules="{required: false}"/>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-3">
                  <InputSelect
                    v-model="form.dangerousGoodsJson.packingType"
                    :options="getDangerousGoodsPackingTypeOptions"
                    :label="$t('outer_packaging')"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-3">
                  <InputText
                    v-model="form.dangerousGoodsJson.innerPackaging"
                    :label="$t('inner_packaging')"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-2">
                  <InputText
                    v-model="form.dangerousGoodsJson.packingInstruction"
                    :label="$t('packing_inst')"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-2">
                  <InputText
                    v-model="form.dangerousGoodsJson.ems"
                    :label="$t('EmS')"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-2">
                  <InputText
                    v-model="form.dangerousGoodsJson.flashPoint"
                    :label="$t('flash_point')"
                    :rules="{required: false}"/>
                </div>
              </div>
            <div class="separator"></div>
              <div class="row m-b-30">
                <div class="col-xs-4">
                  <InputSelect
                    :label="$t('limitations')"
                    v-model="form.dangerousGoodsJson.iataLimitations"
                    :options="iataLimitationOptions"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-4">
                  <InputSelect
                    :label="$t('radioactive')"
                    v-model="form.dangerousGoodsJson.iataRadioactive"
                    :options="iataRadiationOptions"
                    :rules="{required: false}"/>
                </div>
                <div class="col-xs-3">
                  <InputText
                    v-model="form.dangerousGoodsJson.iataAutorization"
                    :label="$t('iata_autorization')"
                    :rules="{required: false}"/>
                </div>
                  <div class="col-xs-1">
                    <InputText
                      v-model="form.dangerousGoodsJson.Q"
                      :label="$t('Q')"
                      :rules="{required: false}"/>
                  </div>
              </div>
            <div class="row m-b-20">
              <div class="col-xs-6">
                <InputText
                  v-model="form.dangerousGoodsJson.danishTechnicalDesignation"
                  :label="$t('technical_designation_national')"
                  :rules="{required: false}"/>
              </div>
              <div class="col-xs-6">
                <InputText
                  v-model="form.dangerousGoodsJson.englishTechnicalDesignation"
                  :label="$t('technical_designation_international')"
                />
              </div>

              </div>
          </div>
        </div>
      </div>
      <div class="text-box m-t-20">
        <div class="card">
          <div class="d-inline-block">
            <Toggle
              id="isShowTempControll"
              class="m-r-10"
              v-model="showTempControll"
              :label="$t('needs_temp_contoller')"/>
            {{ $t('Temperature controlled') }}
          </div>
          <div v-if="showTempControll">
            <div class="separator"></div>
            <div class="row">
            <div class="col-xs-6">
              <InputText
                v-model="form.minTemperature"
                :label="$t('min_temperature')"
                :rules="{required: false}"/>
            </div>
            <div class="col-xs-6">
              <InputText
                v-model="form.maxTemperature"
                :label="$t('max_temperature')"
                :rules="{required: false}"/>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Btn from '@/components/elements/buttons/button.vue';
import mixins from '@/mixins/mixins';
import formValidator from '@/mixins/formValidator';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import InputTextArea from '@/components/elements/inputs/textArea.vue'
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import CurrencySelect from '@/components/elements/inputs/currencySelect.vue';
import {mapGetters} from "vuex";
import ConfirmationBar from "@/components/global/confirmationBar/index.vue";
import {isEqual} from "lodash";

const defaultFormObj = {
  id: '',
  isVisible: '0',
  name: '',
  description: '',
  skuCode: '',
  eanNumber: '',
  unitWeight: {
    unit: 'kg',
    value: null,
  },
  originCountry: '',
  hsCode: '',
  salesPrice: {
    unit: 'dkk',
    value: null,
  },
  purchasePrice: {
    unit: 'dkk',
    value: null,
  },
  minTemperature: '',
  maxTemperature: '',
  image: '',
  accessibleForSubaccounts: [],
  dangerousGoodsJson: [
    {
      Q: '',
      packingType: '',
      iataLimitations: '',
      iataRadioactive: '',
      iataAdditionalInfo: '',
      feeWrapperId: '',
      dangerousGoodsId: '',
      nemWeight: {
        unit: 'kg',
        value: null,
      },
      netWeight: {
        unit: 'kg',
        value: null,
      },
      bruttoWeight: {
        unit: 'kg',
        value: null,
      },
      englishTechnicalDesignation: '',
      danishTechnicalDesignation: '',
      iataAutorization: '',
      flashPoint: '',
      segregationGroup: '',
      ems: '',
      notAllInOneOuterPackaging: '',
      innerPackaging: '',
      packingInstruction: '',
      isMarinePollutant: '',
      isEnvironmentalHazard: '',
    }
  ]
};

export default {
  name: 'item',
  components: {
    ConfirmationBar,
    CurrencySelect,
    CountrySelect,
    Toggle,
    WeightSelect,
    InputSelect,
    InputText,
    InputTextArea,
    Btn,
  },
  mixins: [mixins, formValidator],
  data() {
    return {
      showDangerousGoods: false,
      showTempControll: false,
      savebarEnabled: true,
      showSavebar: false,
      isEnvironmentalHazard: false,
      isMarinePollutant: false,
      dangerousGoodsOptions: [], //Un codes
      form: defaultFormObj,
      iataLimitationOptions: [
        {
          text: `${this.$t('passenger_and_cargo_aircraft')}`,
          value: 1,
        },
        {
          text: `${this.$t('cargo_aircraft_only')}`,
          value: 2,
        },
      ],
      iataRadiationOptions: [
        {
          text: `${this.$t('non_radioactive')}`,
          value: 1,
        },
        {
          text: `${this.$t('radioactive')}`,
          value: 2,
        },
      ],
    }
  },
  created() {
    if (this.isEditMode) {
      this.$store.dispatch('GET_ITEM', this.$route.params.id).then(() => {
        const dangerousGoods = this.get_item.dangerous_goods[0] ? this.get_item.dangerous_goods[0] : ''
        this.form = {
          isVisible: this.get_item.is_visible,
          name: this.get_item.name,
          description: this.get_item.description,
          skuCode: this.get_item.sku_code,
          eanNumber: this.get_item.ean_number,
          unitWeight: {
            unit: this.get_item.weight_unit ? this.get_item.weight_unit : 'kg',
            value: this.get_item.weight,
          },
          originCountry: this.get_item.origin_country_id ? this.get_item.origin_country_id : '',
          hsCode: this.get_item.hs_code,
          salesPrice: {
            unit: this.get_item.sales_price_currency ? this.get_item.sales_price_currency :'dkk',
            value: this.get_item.sales_price ? this.get_item.sales_price : '',
          },
          purchasePrice: {
            unit:  this.get_item.purchase_price_currency ? this.get_item.purchase_price_currency :'dkk',
            value: this.get_item.purchase_price ? this.get_item.purchase_price : '',
          },
          minTemperature: this.get_item.min_temp ? this.get_item.min_temp : '',
          maxTemperature: this.get_item.max_temp ? this.get_item.max_temp : '',
          image: this.get_item.image,
          dangerousGoodsOptions: [], //Un codes
          accessibleForSubaccounts:  this.get_item.accessible_for_subaccounts,
          dangerousGoodsJson:
            {
              Q: dangerousGoods.Q,
              packingType: dangerousGoods.packingType,
              iataLimitations: dangerousGoods.iataLimitations,
              iataRadioactive: dangerousGoods.iataRadioactive,
              iataAdditionalInfo: dangerousGoods.iataAdditionalInfo,
              allPackedInOne: dangerousGoods.allPackedInOne,
              feeWrapperId: dangerousGoods.feeWrapperId,
              dangerousGoodsId: dangerousGoods.dangerousGoodsId,
              nemWeight: dangerousGoods.nemWeight,
              netWeight: dangerousGoods.netWeight,
              bruttoWeight: dangerousGoods.bruttoWeight,
              englishTechnicalDesignation: dangerousGoods.englishTechnicalDesignation,
              danishTechnicalDesignation: dangerousGoods.danishTechnicalDesignation,
              iataAutorization: dangerousGoods.iataAutorization,
              flashPoint: dangerousGoods.flashPoint,
              segregationGroup: dangerousGoods.segregationGroup,
              ems: dangerousGoods.ems,
              innerPackaging: dangerousGoods.innerPackaging,
              packingInstruction: dangerousGoods.packingInstruction,
              isEnvironmentalHazard: dangerousGoods.isEnvironmentalHazard ? 1 : 0,
              isMarinePollutant: dangerousGoods.isEnvironmentalHazard ? 1 : 0,
            }
        }
        this.shouldShowDangerousGoods()
        this.shouldShowTempControlled()
        this.shouldShowEnvHazard()

        this.$nextTick(() => {
          this.savebarEnabled = true;
          this.showSavebar = false;
        })
      });
    }
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id
    },
    ...mapGetters([
      'get_item',
      'get_dangerous_goods_options',
      'get_dangerous_goods_services',
      'get_dangerous_goods_service_by_id',
      'get_dangerous_goods_packing_types',
      'get_subaccounts',
      'get_user',
      'get_is_admin'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id)}));
    },
    getDangerousGoodsServices() {
      return this.get_dangerous_goods_services;
    },
    hasFeeWrapperId() {
      return !!this.feeWrapperId;
    },
    getDangerousGoodsPackingTypeOptions() {
      return this.get_dangerous_goods_packing_types.map((type) => {
        return {text: this.$t(type), value: type}
      });
    },
    computedObjectToBeWatched() {
        return Object.assign({}, JSON.parse(JSON.stringify(this.form)))
    }
  },
  mounted() {
    if (this.form.dangerousGoodsJson) {
      this.setDangerousGoodsOptions();
    }
    this.$store.dispatch('GET_DANGEROUS_GOODS').then((res) => {
      this.setDangerousGoodsOptions()
    })
  },
  methods: {
    saveItemData() {
      const dataArray = {
        accessible_for_subaccounts: this.form.accessibleForSubaccounts,
        is_visible: this.form.isVisible,
        name: this.form.name,
        description: this.form.description,
        sku_code: this.form.skuCode,
        ean_number: this.form.eanNumber,
        weight: this.form.unitWeight,
        origin_country_id: this.form.originCountry,
        hs_code: this.form.hsCode,
        sales_price: this.form.salesPrice,
        purchase_price: this.form.purchasePrice,
        min_temp: this.form.minTemperature,
        max_temp: this.form.maxTemperature,
        image: this.form.image,
        dangerousGoodsOptions: [], //Un codes
      }

      if (this.showDangerousGoods) {
        dataArray.dangerous_goods_json = [{
          Q: this.form.dangerousGoodsJson.Q,
            packingType: this.form.dangerousGoodsJson.packingType,
            iataLimitations: this.form.dangerousGoodsJson.iataLimitations,
            iataRadioactive: this.form.dangerousGoodsJson.iataRadioactive,
            iataAdditionalInfo: this.form.dangerousGoodsJson.iataAdditionalInfo,
            feeWrapperId: this.form.dangerousGoodsJson.feeWrapperId,
            dangerousGoodsId: this.form.dangerousGoodsJson.dangerousGoodsId,
            nemWeight: this.form.dangerousGoodsJson.nemWeight,
            netWeight: this.form.dangerousGoodsJson.netWeight,
            bruttoWeight: this.form.dangerousGoodsJson.bruttoWeight,
            englishTechnicalDesignation: this.form.dangerousGoodsJson.englishTechnicalDesignation,
            danishTechnicalDesignation: this.form.dangerousGoodsJson.danishTechnicalDesignation,
            iataAutorization: this.form.dangerousGoodsJson.iataAutorization,
            flashPoint: this.form.dangerousGoodsJson.flashPoint,
            segregationGroup: this.form.dangerousGoodsJson.segregationGroup,
            ems: this.form.dangerousGoodsJson.ems,
            innerPackaging: this.form.dangerousGoodsJson.innerPackaging,
            packingInstruction: this.form.dangerousGoodsJson.packingInstruction,
            isEnvironmentalHazard: this.form.dangerousGoodsJson.isEnvironmentalHazard ? 1 : 0,
            isMarinePollutant: this.form.dangerousGoodsJson.isEnvironmentalHazard ? 1 : 0
        }]
      }

      if (!this.isEditMode) {
        this.$store.dispatch('ADD_ITEM', dataArray).then(() => {
          if (this.$store.getters.get_item.id) {
            this.$store.dispatch('UPLOAD_ITEM_IMAGE', {
              file: this.$refs.imageUploadInput.files[0],
              id: this.$store.getters.get_item.id
            })

            this.showSavebar = false;
            const id = this.$store.getters.get_item.id
            this.$router.push(`${id}/edit-item`);
          }
          this.showSavebar = false;
        });
      } else {
        this.$store.dispatch('EDIT_ITEM', {
          id: this.$route.params.id,
          form: dataArray
        }).then(() => {
          this.showSavebar = false;
        })
      }
    },
    cancel() {
      this.showSavebar = false;
    },
    routeIt() {
      this.$router.push('/items');
    },
    setDangerousGoodsOptions() {
      this.dangerousGoodsOptions = this.get_dangerous_goods_options;
    },
    selectAccessibleSubaccount(val) {
      if (val.length > 0) {
        this.form.accessibleForSubaccounts = val;
      }
    },
    uploadImage() {
      this.$refs.imageUploadInput.click();
    },
    imageSelected() {
      this.showSavebar = true;
      this.form.image = URL.createObjectURL(
        this.$refs.imageUploadInput.files[0],
      );

      if (this.isEditMode) {
        this.$store.dispatch('UPLOAD_ITEM_IMAGE', {
          id: this.$route.params.id,
          file: this.$refs.imageUploadInput.files[0],
        }).then(() => {
          this.$store.dispatch('GET_ITEM', this.$route.params.id);
          this.showSavebar = false;
        });
      }
    },
    shouldShowDangerousGoods() {
      this.showDangerousGoods = parseInt(this.get_item.contains_dangerous_goods) === 1;
    },
    shouldShowTempControlled() {
      this.showTempControll = parseInt(this.get_item.contains_temp_controlled) === 1;
    },
    shouldShowEnvHazard() {
      this.isEnvironmentalHazard = parseInt(this.get_item.dangerous_goods[0].isEnvironmentalHazard) === 1;
    }
  },
  watch: {
    'isEnvironmentalHazard': {
      handler() {
        if (this.isEnvironmentalHazard) {
          this.form.dangerousGoodsJson.isEnvironmentalHazard = 1;
          this.form.dangerousGoodsJson.isMarinePollutant = 1;
        } else {
          this.form.dangerousGoodsJson.isEnvironmentalHazard = 0
          this.form.dangerousGoodsJson.isMarinePollutant = 0;
        }

        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    computedObjectToBeWatched: {
      handler(newVal, oldVal) {
        if (this.savebarEnabled && (!isEqual(newVal, oldVal) && (!this.isEditMode || !isEqual(oldVal, defaultFormObj)))) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    showDangerousGoods: {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    showTempControll: {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
/*    'form.accessibleForSubaccounts': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.name': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.description': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.isVisible': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.image': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.unitWeight': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.originCountry': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.hsCode': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.salesPrice': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.purchasePrice': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.minTemperature': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.maxTemperature': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.dangerousGoodsJson': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.skuCode': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.eanNumber': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },*/
  },
}
</script>
